import { useWatch } from "react-hook-form";
import { ConsentItem } from "./types";

interface UseConsentGroupParams {
  items: ConsentItem[];
  control: any;
  setValue: any;
  onSelectAll?: (checked: boolean) => void;
}

interface UseConsentGroupResult {
  isAllChecked: boolean;
  showSelectAll: boolean;
  handleSelectAll: () => void;
}

const useConsentGroup = ({ items, control, setValue, onSelectAll }: UseConsentGroupParams): UseConsentGroupResult => {
  const fieldNames = items.map((item) => item.fieldName);
  const values = useWatch({ control, name: fieldNames });

  const valuesArray = Array.isArray(values) ? values : [values];
  const isAllChecked = fieldNames.length > 0 && valuesArray.every(Boolean);
  const showSelectAll = items.length > 1 || !!onSelectAll;

  const handleSelectAll = () => {
    const nextValue = !isAllChecked;
    items.forEach(({ fieldName }) => {
      setValue(fieldName, nextValue, { shouldValidate: true });
    });
    onSelectAll?.(nextValue);
  };

  return { isAllChecked, showSelectAll, handleSelectAll };
};

export default useConsentGroup;
